import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { IconProps } from '../NavigationBar/Icon/IconProps'
import NavigationBarButtonWithBackground from '../../BaseComponents/Button/NavigationBar/WithBackground'

export type NavigationBarIconProps = IconProps & {
    onPress: () => void
}
export type NavigationBarProps = {
    /**
     * icon on the left side
     */
    leftIcon: NavigationBarIconProps
    marginLeft?: number
}

const ImageNavigationBar: FunctionComponent<NavigationBarProps> = ({
    leftIcon,
    marginLeft,
}): ReactElement => {
    return (
        <Grid pointerEvents="box-none" horizontal noExpand minHeight={44} centerVertical>
            <NavigationBarButtonWithBackground
                color={leftIcon?.color}
                onPress={leftIcon.onPress}
                name={leftIcon.name}
                marginX={marginLeft}
            />
        </Grid>
    )
}

export default memo(ImageNavigationBar)
